import { MouseEventHandler, ReactElement } from "react";
import {
  Box,
  Flex,
  Image,
  chakra,
  HStack,
  Icon,
  Avatar,
  Text,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { HiOutlineBell } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setHistory } from "../../services/state/history/history";
import { CgMenuGridO } from "react-icons/cg";
import verticalAgents from "../../assets/images/vertical_agents.png";
import videoAnalytics from "../../assets/images/video_analytics.png";
import administrator from "../../assets/images/administator.png";
import designer from "../../assets/images/design.jpeg";
// import eizenLogo from "../../assets/images/Logo.png";
import eizenLogo from "../../assets/images/eizenlogof.svg";
import { RootState } from "@/services/state/store";

interface IHeaderProps {
  children: ReactElement;
}

const Header: React.FC<IHeaderProps> = ({ children }) => (
  <chakra.header
    width="100%"
    bgColor="rgba(0, 0, 0, 0.4)"
    backdropFilter="blur(20px)"
    borderBottom="1px solid rgba(255, 255, 255, 0.1)"
    boxShadow="0 4px 20px rgba(0, 0, 0, 0.3)"
    position="fixed"
    px={6}
    py={3}
    zIndex={9999}
  >
    {children}
  </chakra.header>
);

const Alert = ({ onClick }: { onClick: MouseEventHandler<SVGElement> }) => (
  <Icon
    as={HiOutlineBell as React.ElementType}
    boxSize={6}
    onClick={onClick}
    cursor="pointer"
  />
);

const User: React.FC<{ onProfile: () => void }> = ({ onProfile }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigation = (path: string) => {
    path.startsWith("http")
      ? window.open(path, "_blank", "noopener,noreferrer")
      : dispatch(setHistory(path)) && navigate(path);
  };

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={
          <Icon
            as={CgMenuGridO as React.ElementType}
            boxSize={8}
            color="white"
          />
        }
        variant="ghost"
        _hover={{
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        }}
        title=""
      />
      <MenuList
        bg="rgba(0, 0, 0, 0.95)"
        backdropFilter="blur(20px)"
        border="1px solid rgba(255, 255, 255, 0.2)"
        borderRadius="8px"
        boxShadow="0 8px 32px rgba(0, 0, 0, 0.3)"
        zIndex={99999}
        minW="200px"
        p={2}
      >
        {[
          {
            label: "Designer",
            path: "/platform/design/applications",
            img: designer,
          },
          {
            label: "Administration",
            path: "/platform/admin/administration",
            img: administrator,
          },
          {
            label: "Agents",
            path: "https://agent-ldev.eizen.ai",
            img: verticalAgents,
          },
          {
            label: "Video Analytics",
            path: "https://vip-ldev.eizen.ai",
            img: videoAnalytics,
          },
        ].map(({ label, path, img }) => (
          <MenuItem
            key={label}
            onClick={() => handleNavigation(path)}
            bg="transparent"
            _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
            _focus={{ bg: "rgba(255, 255, 255, 0.1)" }}
            color="white"
            borderRadius="4px"
            mb={1}
            p={2}
            cursor="pointer"
          >
            {img && <Image src={img} boxSize={"28px"} mr={2} />}
            <Text color="white">{label}</Text>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

const AuthenticatedHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const navigateWithHistory = (path: string) => {
    dispatch(setHistory(location.pathname));
    navigate(path);
  };

  const isLogoEnaable = useSelector(
    (state: RootState) => state.administration.isLogoEnabled
  );

  return (
    <Header>
      <Flex
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        // bg="#9500ff"
        mx={-6}
        my={-4}
        px={2}
        py={4}
      >
        <HStack gap={1}>
          {isLogoEnaable && <Image src={eizenLogo} width={"30px"} ml={2} />}
          <Text fontSize="24px" px={2} color="white" fontWeight="bold">
            {isLogoEnaable ? "eizen agentic platform" : "agentic platform"}
          </Text>
        </HStack>
        <HStack spacing={2}>
          <User onProfile={() => navigateWithHistory("/profile")} />
          <Avatar
            bg="brand.500"
            size="sm"
            cursor="pointer"
            onClick={() => navigateWithHistory("/profile")}
          />
        </HStack>
      </Flex>
    </Header>
  );
};

export default AuthenticatedHeader;
